import React from 'react';
import SelectControl from './SelectControl';
import FormControl from './FormControl';
import i18n from '../../../../src/i18n/translate';
import { DROPDOWN_SEARCH_MINIMUM } from '../../../constants';
import moment from 'moment-timezone';

export default class TimezoneControl extends FormControl{

  optionsFromMoment = () => {
    let tzList = [];
    moment.tz.names().map((name) => {
      if (typeof name === 'string' &&
        name.indexOf('/') > -1 &&
        name.indexOf('Etc/') === -1) {
        tzList.push({ name, value: name });
      }
    });
    return tzList;
  }

  render(){
    let translationProps = {
      searchPromptText: i18n.t("Type to search"),
      noResultsText: i18n.t("No results found"),
      loadingPlaceholder: i18n.t("Loading..."),
      clearAllText: i18n.t("Clear all"),
      clearValueText: i18n.t("Clear value")
    }
    const { setError, name, ...props } = this.props;
    return (<SelectControl
      {...props}
      labelKey="name"
      name={name}
      options={this.optionsFromMoment()}
      onBlur={this.onBlur}
      onChange={this.onChange}
      onFocus={this.onFocus}
      placeholder={this.props.placeholderText}
      ref={(select) => (this.select = select)}
      scrollMenuIntoView={false}
      removeSelected={false}
      searchable={this.props.options && !this.props.options.length < DROPDOWN_SEARCH_MINIMUM} {...translationProps}
      setError={setError}
      value={this.state.value ? this.state.value : moment.tz.guess()}
      valueKey="value"
    />);
  }
}
